export const LIGHTBOX_SET_VISIBLE = 'LSV';
export const LIGHTBOX_SET_MEDIA = 'LSM';
export const SIDEBAR_SET_URL = 'SIDEBAR_SET_URL';
export const SIDEBAR_SET_VISBILE = 'SIDEBAR_SET_VISIBLE';
export const SEARCH_QUERY_SET = 'SEARCH_QUERY_SET';

export default {
    [LIGHTBOX_SET_MEDIA](state, media) {
        state.lightboxMedia = media;
    },

    [LIGHTBOX_SET_VISIBLE](state, visible) {
        state.lightboxVisible = visible
    },

    [SIDEBAR_SET_URL](state, url) {
        state.sidebarUrl = url
    },

    [SIDEBAR_SET_VISBILE](state, visible) {
        state.sidebarVisible = visible
    },

    [SEARCH_QUERY_SET](state, value) {
        state.searchQuery = value;
    },
}